// Render-time text hygiene. The pipeline data can carry em/en dashes in
// question text and written reads; the portal-wide rule is NO fancy dashes
// in anything rendered (user, standing). This replaces them at DISPLAY
// time only - the stored data is never touched.
export const stripDashes = (v) =>
  typeof v === "string" ? v.replace(/\s*[\u2014\u2013\u2015\u2212]\s*/g, " - ") : v;

/* Model-written labels arrive lowercase ("worried", "no concerns expressed").
   Capitalise the first letter at DISPLAY time only - the stored value is the
   join key for drill-downs and must not change (user 2026-08-24: "is it
   coming directly variable? coz no first alphabet capital"). */
export const capitalize = (v) =>
  typeof v === "string" && v.length ? v.charAt(0).toUpperCase() + v.slice(1) : v;
